// extracted by mini-css-extract-plugin
export default {"grid":"order-page_grid__5rX0r","left":"order-page_left__p9ij0"};